import { render, staticRenderFns } from "./RecentSearch.vue?vue&type=template&id=a955e664&scoped=true&"
import script from "./RecentSearch.vue?vue&type=script&lang=js&"
export * from "./RecentSearch.vue?vue&type=script&lang=js&"
import style0 from "./RecentSearch.vue?vue&type=style&index=0&id=a955e664&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a955e664",
  null
  
)

export default component.exports